<template>
  <error text="ERROR DE CONEXION" />
</template>

<script>
import error from "../../components/shared/error/error.vue";
export default {
  components: {
    error,
  },
  // name: "401",
};
</script>